import { SelectField, TextField } from '../../components/common'
import { FormProps, SectionHeading, UpdateButton, useSettingsForm } from './forms'
import styles from './SettingsPage.module.scss'

export function PrescriptionForm({
  settings,
  onDirty,
  onClean,
  onSubmit,
  onEditSection,
}: FormProps<{ print_config: string }> & { onEditSection: (section: string) => void }) {
  const { professional, profession, health_center, print_configs } = settings
  const { values, set, submitting, handleSubmit, formRef } = useSettingsForm(
    { print_config: health_center.print_config },
    { onDirty, onClean, onSubmit },
  )

  const editLink = (section: string) => (
    <a
      href={`#${section}`}
      className={`edit-link ${styles.editLink}`}
      onClick={(event) => {
        event.preventDefault()
        onEditSection(section)
      }}
    >
      (editar)
    </a>
  )

  return (
    <form ref={formRef} onSubmit={handleSubmit}>
      <h3 className="text-center blue-subtitle">Configuración de recetas</h3>
      <div className="col-md-12">
        <SectionHeading>Información del profesional {editLink('professional')}</SectionHeading>
        <TextField className="col-xs-6" label="RUT" value={professional.rut ?? ''} disabled onChange={() => {}} />
        {profession?.can_prescript_recipes && (
          <>
            <TextField className="col-xs-6" label="I.C.M" value={professional.icm ?? ''} disabled onChange={() => {}} />
            <TextField className="col-xs-6" label="REG-SIS Nº" value={professional.reg_sis ?? ''} disabled onChange={() => {}} />
          </>
        )}
        <TextField className="col-xs-6" label="Profesión" value={profession?.title ?? ''} disabled onChange={() => {}} />

        <SectionHeading>Información del Centro {editLink('health-center')}</SectionHeading>
        <TextField className="col-xs-6" label="Nombre" value={health_center.name ?? ''} disabled onChange={() => {}} />
        <TextField className="col-xs-6" label="Dirección" value={health_center.address ?? ''} disabled onChange={() => {}} />
        <TextField className="col-xs-6" label="Teléfono" value={health_center.phone ?? ''} disabled onChange={() => {}} />

        <div className="col-xs-12">
          <SectionHeading>Formato de impresión</SectionHeading>
        </div>
        <div className="col-xs-12">
          <div className={styles.printConfig}>
            <div className={styles.printConfigInput}>
              <SelectField
                label="Formato de impresión"
                value={values.print_config}
                onChange={set('print_config')}
                options={print_configs.map((config) => ({ value: config.value, label: config.label }))}
              />
            </div>
            <div className={styles.printConfigPreview}>
              <img
                src={print_configs.find((config) => config.value === values.print_config)?.preview}
                className={styles.paperPreview}
                alt={values.print_config}
              />
            </div>
          </div>
        </div>
        <div className="col-xs-12">
          <UpdateButton submitting={submitting} />
        </div>
      </div>
    </form>
  )
}
